module.exports = __webpack_public_path__ + "static/media/bg.57878a92.png";